const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '1080P 高清画质',
    desc: '全平台支持1080P全高清播放，精细画面呈现每一个剧情细节，让追剧成为视觉享受。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '全球CDN节点智能分发，根据网络状况自适应码率，确保观影过程流畅无卡顿。',
  },
  {
    id: 3,
    icon: 'ri-translate',
    title: '专业中文字幕',
    desc: '资深日韩语翻译团队精心制作字幕，语义准确、表达地道，让您完全沉浸在剧情中。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '与日韩播出保持同步，热门剧集播出后最快24小时上线，追剧永远快人一步。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            为什么千万日韩剧迷选择日韩影视网
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {features.map((item) => (
            <article
              key={item.id}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200/50 transition-all duration-200 text-center"
            >
              <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-sm font-bold font-heading text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}